import * as ActionTypes from 'state/types'
import Routes from 'shared/utils/api/routes'

export const initNotifications = () => ({
  type: ActionTypes.INIT_NOTIFICATIONS
})

export const subscribePushClient = (endpoint,key,authSecret) => ({
  type: ActionTypes.SUBSCRIBE_PUSH_CLIENT_REQUEST,
  payload: {
    url: Routes.SUBSCRIPTIONS_SAVE_ROUTE,
    method: 'post',
    data: {
      endpoint,
      key,
      authSecret
    }
  }
})

export const unsubscribePushClient = () => ({
  type: ActionTypes.UNSUBSCRIBE_PUSH_CLIENT
})

export const showActivityNotification = activity => sendNotification('Message received', activity.speech)

const sendNotification = (title, body) => ({
  type: ActionTypes.SHOW_NOTIFICATION,
  payload: {
    title,
    body,
    tag: null
  },
  meta: { sound: 'notification' }
})
